module.exports = __webpack_public_path__ + "static/img/213_TO8_2157_og.584c179.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/213_TO8_2157_og.jpg
// module id = RVWz
// module chunks = 0